export namespace FileConstants {
  export const fileSizeLimit = 2097152;
  export const fileSizeErrorMsg = 'File Size should be less than 2MB';

  export enum FileSection {
    Profile = 1,
  }
}
